import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

/**
 * Home Partners strip
 * - Logos display in their natural colours (no grayscale).
 * - Uses `logo_url` only (name/website are no longer required).
 * - Includes a compact "View all →" link routing to /partners.
 */
const PartnersSection = ({ partners = [] }) => {
    const visible = partners.filter((p) => (p.logo_url || '').trim() !== '');
    if (!visible.length) return null;

    return (
        <section className="section-pad" data-testid="home-partners-section">
            <div className="container-page">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
                    <div className="max-w-2xl">
                        <div className="flex items-center gap-3 mb-3">
                            <span className="accent-bar" />
                            <span className="text-[hsl(var(--accent))] font-semibold text-xs uppercase tracking-widest">
                                Our Partners
                            </span>
                        </div>
                        <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-foreground">
                            Working alongside those who believe in the mission.
                        </h2>
                        <p className="mt-3 text-muted-foreground text-base leading-relaxed">
                            Corporates, government bodies and community
                            organisations.
                        </p>
                    </div>
                    <Link
                        to="/partners"
                        data-testid="home-partners-view-all"
                        className="inline-flex items-center gap-1.5 self-start sm:self-end text-sm font-semibold text-[hsl(var(--primary))] hover:underline underline-offset-4 whitespace-nowrap"
                    >
                        View all
                        <ArrowRight className="h-3.5 w-3.5" />
                    </Link>
                </div>

                <div className="mt-2" data-testid="partners-strip">
                    <ScrollArea className="w-full whitespace-nowrap">
                        <div className="flex items-center gap-6 py-4">
                            {visible.map((p) => (
                                <div
                                    key={p.id}
                                    className="shrink-0 h-20 w-44 flex items-center justify-center rounded-lg border border-border bg-white p-3 transition-transform hover:-translate-y-0.5"
                                    data-testid={`partner-logo-${p.id}`}
                                >
                                    <img
                                        src={p.logo_url}
                                        alt=""
                                        loading="lazy"
                                        className="max-h-12 max-w-full object-contain"
                                        onError={(e) => {
                                            e.currentTarget.style.display =
                                                'none';
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                        <ScrollBar orientation="horizontal" />
                    </ScrollArea>
                </div>
            </div>
        </section>
    );
};

export default PartnersSection;
